import React, {useCallback, useContext, useEffect, useState} from "react";
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Button from "@material-ui/core/Button";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import {makeStyles} from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CheckBox from '../../Components/CheckBox';
import API_Service, {axiosDefaultConfig} from '../../Services/API_Service';
import {
	ck_session_id,
	ck_u_client,
	ck_u_device_no,
	ck_u_login_id,
	ck_u_password,
	ck_u_position,
	ck_u_remember_auth,
	ck_u_role_id,
	ck_u_salesperson,
	ck_u_selforder,
	ck_u_username,
	empty,
	no,
	req_login,
	yes
} from "../../Helper/Constants";
import JString from '@easytech-international-sdn-bhd/jstring';
import History from '../../Services/History';
import _ from 'lodash';
import {useSnackbar} from 'notistack';
import CryptData from "../../Helper/CryptData";
import AppContext from "../../Services/AppContext";
import LinearLoading from "../../Components/LinearLoading";
import * as firebase from '../../Firebase';
import {de} from "../../Helper/Helper";
import useCookieHook from "../../Services/useCookieHook";
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import {ops, tables} from "../../Services/indexedDB";
import PersistantData from "../../Services/PersistantData";

const FEATURE_KEYS = [
	'login_feature_1',
	'login_feature_2',
	'login_feature_3',
	'login_feature_4',
];

const useStyles = makeStyles(theme => ({
	root: {
		minHeight: '100vh',
		display: 'flex',
		flexDirection: 'row',
		backgroundImage: `url(${process.env.PUBLIC_URL}/login_bg.jpg)`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
		position: 'relative',
		'&::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: 'rgba(0,0,0,0.5)',
			zIndex: 0,
			display: 'none',
		},
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column',
			'&::before': {
				display: 'block',
			},
		},
	},
	leftSection: {
		flex: '0 0 55%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		padding: '60px 60px 60px 80px',
		color: '#ffffff',
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	rightSection: {
		flex: '0 0 45%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		[theme.breakpoints.down('sm')]: {
			flex: 1,
			padding: 20,
			zIndex: 1,
		},
	},
	logo: {
		maxWidth: 200,
		marginBottom: 32,
	},
	tagline: {
		fontSize: 42,
		fontWeight: 800,
		lineHeight: 1.2,
		letterSpacing: -0.5,
		color: '#ffffff',
		margin: 0,
	},
	subtitle: {
		fontSize: 17,
		color: 'rgba(255,255,255,0.7)',
		marginTop: 16,
		lineHeight: 1.7,
	},
	featureList: {
		marginTop: 32,
		listStyle: 'none',
		padding: 0,
	},
	featureItem: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: 14,
		fontSize: 16,
		color: '#ffffff',
	},
	featureIcon: {
		color: '#FEF200',
		fontSize: 22,
		marginRight: 12,
	},
	trustedBy: {
		marginTop: 40,
		fontSize: 14,
		fontWeight: 600,
		letterSpacing: 0.5,
		textTransform: 'none',
		color: 'rgba(255,255,255,0.85)',
	},
	loginCard: {
		backgroundColor: '#ffffff',
		borderRadius: 20,
		padding: '44px 40px',
		width: 440,
		boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			maxWidth: 440,
			padding: '32px 24px',
		},
	},
	cardLogo: {
		maxWidth: 130,
		marginBottom: 20,
	},
	cardTitle: {
		fontSize: 26,
		fontWeight: 700,
		color: '#222222',
		marginBottom: 4,
		[theme.breakpoints.down('sm')]: {
			fontSize: 22,
		},
	},
	cardSubtitle: {
		fontSize: 14,
		color: '#999999',
		marginBottom: 32,
	},
	inputField: {
		width: '100%',
		marginBottom: 20,
		'& .MuiOutlinedInput-root': {
			borderRadius: 10,
			fontSize: 15,
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#FEF200',
		},
		'& .MuiInputLabel-root.Mui-focused': {
			color: '#c4a600',
		},
	},
	loginBtn: {
		width: '100%',
		backgroundColor: '#FEF200',
		color: '#000000',
		fontWeight: 700,
		fontSize: 16,
		borderRadius: 10,
		padding: '14px 0',
		textTransform: 'none',
		marginTop: 4,
		'&:hover': {
			backgroundColor: '#e6da00',
			boxShadow: '0 4px 12px rgba(254,242,0,0.4)',
		},
		'&.Mui-disabled': {
			backgroundColor: '#f5f0a0',
			color: 'rgba(0,0,0,0.4)',
		},
	},
}));

export default function SignIn() {
	const styles = useStyles();
	const {enqueueSnackbar} = useSnackbar();
	const [gState, setGState] = useContext(AppContext);
	const singleton = PersistantData.getInstance();
	var {translation: language} = gState;
	if (!language) language = singleton.getlang();

	const [axiosConfig, setAxiosConfig] = useState({});
	const [sessionid, setSessionId] = useState(empty);
	const [showPassword, setShowPassword] = useState(false);

	const [state, setState] = useState({
		username: empty,
		password: empty,
		remember_me: false,
		isWrongPassword: false,
		loginInProgress: false
	});

	const [cookies, setCookie, , cookieInstance] = useCookieHook([
		ck_u_client, ck_u_login_id, ck_u_password, ck_u_role_id, ck_u_username, ck_u_remember_auth, ck_u_salesperson, ck_u_selforder
	]);
	var u_client = cookies(ck_u_client);
	var u_username = cookies(ck_u_username);
	var u_password = cookies(ck_u_password);
	var u_remember_auth = cookies(ck_u_remember_auth);

	if (JString(u_username).isValid()) {
		u_client = JString(u_client).isValid() ?
			new CryptData(u_client, u_username)
				.decryptAES()
				.getValue()
			: empty;
		u_password = JString(u_password).isValid() ?
			new CryptData(u_password, u_username)
				.decryptAES()
				.getValue()
			: empty;
	}

	useEffect(() => {
		initFingerPrint();
		if (u_remember_auth === yes && !_.isEmpty(u_client) && !_.isEmpty(u_password) && !_.isEmpty(u_username)) {
			gotoDashboard();
		} else {
			de('cookie remember me?', u_remember_auth, u_client, u_password, u_username);
		}
		var axiosGetConfig = axiosDefaultConfig(gState.client);
		setAxiosConfig(axiosGetConfig);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [u_username, u_client, cookieInstance]);

	const initFingerPrint = async () => {
		const existingFingerPrints = await ops.get(tables.uniques);
		de(existingFingerPrints, '--existing ids--');
		if (existingFingerPrints?.fingerprint) {
			setSessionId(existingFingerPrints.fingerprint);
		} else {
			const fpPromise = FingerprintJS.load();
			await (async () => {
				const fp = await fpPromise;
				const result = await fp.get();
				const fingerprint = result.visitorId;
				ops.insert(tables.uniques, {fingerprint, date_time: new Date().toISOString()});
				setSessionId(fingerprint);
			})();
		}
	}

	const onTextChange = prop => event => {
		setState({...state, [prop]: event.target.value});
	}

	const onCheckboxChange = event => {
		const remember_me_cb = event.target.checked;
		setState({...state, [event.target.name]: remember_me_cb});
	};

	var vUsername = JString(state.username).str;
	var vPassword = JString(state.password).str;

	const checkTokenAndLogin = (svUsername = empty, svPassword = empty) => {
		firebase.initNotification((token) => {
			performLogin(svUsername, svPassword, token);
		}, null);
	}

	const performLogin = (svUsername = empty, svPassword = empty, token = empty) => {
		setState({...state, loginInProgress: true});

		var formdata = new FormData();
		formdata.append('username', svUsername || vUsername);
		formdata.append('password', svPassword || vPassword);
		formdata.append('device_token', token || '');
		formdata.append('fingerprint_id', sessionid);
		API_Service.post(`${req_login}`, formdata, axiosConfig)
			.then(({data}) => {
				if (data) {
					var {result, extraData: e} = data;

					result = JString(result).toNumber();

					if (result === 0) {
						setState({...state, isWrongPassword: result === 0, loginInProgress: false});
					}
					if (e && result === 1) {
						var _position_raw = e.position && JString(e.position).isValid() ? e.position : '{}';
						const lGstate = {
							...gState,
							username: e.username,
							password: e.password,
							client: e.client_company,
							device_no: e.device_no,
							company: e.company,
							position: _position_raw
						};
						setGState(lGstate);
						var _clientId = new CryptData(e.client_company, e.username)
							.isString()
							.encryptAES()
							.getValue();
						var _login_id = new CryptData(e.id, e.username)
							.isString()
							.encryptAES()
							.getValue();
						var _password = new CryptData(e.password, e.username)
							.isString()
							.encryptAES()
							.getValue();
						var _session_id = sessionid;
						var _role_id = new CryptData(e.role, e.username)
							.isString()
							.encryptAES()
							.getValue();
						var _position_enc = new CryptData(_position_raw, e.username)
							.isString()
							.encryptAES()
							.getValue();
						var _is_selfOrder = e.is_selforder;
						var _is_salesperson = e.is_salesperson;

						cookieKeyValue(ck_u_client, _clientId, lGstate);
						cookieKeyValue(ck_u_login_id, _login_id, lGstate);
						cookieKeyValue(ck_u_username, e.username, lGstate);
						cookieKeyValue(ck_u_password, _password, lGstate);
						cookieKeyValue(ck_u_role_id, _role_id, lGstate);
						cookieKeyValue(ck_u_position, _position_enc, lGstate);
						cookieKeyValue(ck_u_salesperson, _is_salesperson, lGstate);
						cookieKeyValue(ck_u_selforder, _is_selfOrder, lGstate);
						cookieKeyValue(ck_session_id, _session_id, lGstate);
						cookieKeyValue(ck_u_remember_auth, state.remember_me ? yes : no, lGstate);
						cookieKeyValue(ck_u_device_no, e.device_no, lGstate);
						sessionStorage.setItem('session', JSON.stringify(lGstate));
						throttleRedirect();
					}
				}
			})
			.catch(() => {
				setState({...state, loginInProgress: false});
				enqueueSnackbar(language["login_network_error"], {variant: 'error'});
			});
	}

	const cookieKeyValue = (key, value, extra = gState) => {
		setCookie(key, value, {path: '/'}, extra);
	}
	const gotoDashboard = () => {
		setState({...state, loginInProgress: false});
		History.push('/main');
	}
	const throttleRedirect = useCallback(_.debounce(gotoDashboard, 1000), []);
	const disabledLoginBtn = (vUsername.length < 3 || vPassword.length < 4) || state.loginInProgress;

	return (
		<>
			<CssBaseline/>
			<div className={styles.root}>
				<div className={styles.leftSection}>
					<img src={`${process.env.PUBLIC_URL}/easym_logo.png`} alt="EasyM" className={styles.logo}/>
					<Typography variant="h3" component="h1" className={styles.tagline}>
						{language["login_tagline"]}
					</Typography>
					<Typography className={styles.subtitle}>
						{language["login_subtitle"]}
					</Typography>
					<div className={styles.featureList}>
						{FEATURE_KEYS.map((key) => (
							<div key={key} className={styles.featureItem}>
								<CheckCircleIcon className={styles.featureIcon}/>
								<span>{language[key]}</span>
							</div>
						))}
					</div>
					<Typography className={styles.trustedBy}>
					{language["login_trusted_by"]}
					</Typography>
				</div>
				<div className={styles.rightSection}>
					<div className={styles.loginCard}>
						<img src={`${process.env.PUBLIC_URL}/easym_logo.png`} alt="EasyM" className={styles.cardLogo}/>
						<Typography className={styles.cardTitle}>
							{language["login_portal_title"]}
						</Typography>
						<Typography className={styles.cardSubtitle}>
							{language["login_portal_subtitle"]}
						</Typography>

						{state.loginInProgress && <LinearLoading/>}

						<TextField
							variant="outlined"
							label={language["username"]}
							error={state.isWrongPassword}
							helperText={state.isWrongPassword ? language["login_check_username"] : ''}
							onChange={onTextChange('username')}
							className={styles.inputField}
						/>
						<TextField
							variant="outlined"
							label={language["password"]}
							type={showPassword ? 'text' : 'password'}
							error={state.isWrongPassword}
							helperText={state.isWrongPassword ? language["login_check_password"] : ''}
							onChange={onTextChange('password')}
							onKeyPress={(ev) => {
								if (ev.key === 'Enter') {
									checkTokenAndLogin();
									ev.preventDefault();
								}
							}}
							className={styles.inputField}
							autoComplete="current-password"
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											size="small"
											edge="end"
											onClick={() => setShowPassword(!showPassword)}
											onMouseDown={(e) => e.preventDefault()}
										>
											{showPassword ? <Visibility/> : <VisibilityOff/>}
										</IconButton>
									</InputAdornment>
								)
							}}
						/>

						<CheckBox
							checked={state.remember_me}
							onChange={onCheckboxChange}
							name="remember_me"
							color="primary"
							text={language["login_remember_me"]}
						/>

						<Button
							onClick={() => checkTokenAndLogin()}
							className={styles.loginBtn}
							disabled={disabledLoginBtn}
							variant="contained"
							disableElevation
						>
							{language["login_access_dashboard"]} &rarr;
						</Button>
					</div>
				</div>
			</div>
		</>
	);
}
